import { LabelSelectorField } from "components/Form/Fields";
import { LabelSelectFieldOption } from "components/Form/FormikControls";
import { getIn, useFormikContext } from "formik";
import React from "react";
import { useSelector } from "react-redux";
import {
  getMasterLabelsBySpecies,
  selectMasterLabelsBySaleLotId,
} from "selectors/labels";
import { getCheckboxFieldName } from "./util";

interface MasterLabelSelectorProps {
  modelIds: number[];
  name: string;
}

export const MasterLabelSelector: React.FC<MasterLabelSelectorProps> = ({
  modelIds,
  name,
}) => {
  const masterLabels: MasterLabel[] = useSelector(getMasterLabelsBySpecies);
  const masterLabelIdsBySaleLotIdLookup = useSelector(
    selectMasterLabelsBySaleLotId,
  );

  const masterLabelsIdsInSelectedLots = new Set();
  modelIds.forEach(slId => {
    masterLabelIdsBySaleLotIdLookup[slId].forEach(mlId =>
      masterLabelsIdsInSelectedLots.add(mlId),
    );
  });

  const { values } = useFormikContext();
  const removeLabels = name === "removeLabels";

  const isSelected = getIn(values, getCheckboxFieldName(name));

  const options: LabelSelectFieldOption[] = masterLabels
    .filter(ml => ml.quickSelect && !ml.deprecated)
    .sort((a, b) => a.order - b.order)
    .map(ml => ({
      label: ml.name,
      value: ml.id,
      isMasterLabel: true,
    }))
    .filter(
      // Only allow removing labels that are in use
      opt => !removeLabels || masterLabelsIdsInSelectedLots.has(opt.value),
    );
  const labelsName = "managed labels";

  return (
    <LabelSelectorField
      name={name}
      label={`Select ${labelsName} to ${removeLabels ? "remove" : "add"}`}
      tooltip={
        removeLabels
          ? `AgriNous ${labelsName} to be removed from selected lots, before any new labels are added.`
          : `AgriNous ${labelsName} to be added to selected lots, after any labels are removed.`
      }
      required={false}
      disabled={!isSelected}
      addLabel={null}
      options={options}
      placeHolder={`Click to ${removeLabels ? "remove" : "add"} ${labelsName}`}
    />
  );
};
